namespace TabAurous.OMS {
    export interface MarkupChargesForm {
        MarkUpType: Serenity.EnumEditor;
        ItemTypeId: Serenity.LookupEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        ProcessId: Serenity.LookupEditor;
        SettingId: Serenity.LookupEditor;
        MarkUpRateType: Serenity.EnumEditor;
        MarkUp: Serenity.DecimalEditor;
    }

    export class MarkupChargesForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.MarkupCharges';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MarkupChargesForm.init)  {
                MarkupChargesForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.LookupEditor;
                var w2 = CommonCategoryLookup;
                var w3 = CommonSubCategoryLookup;
                var w4 = s.DecimalEditor;

                Q.initFormType(MarkupChargesForm, [
                    'MarkUpType', w0,
                    'ItemTypeId', w1,
                    'ProductTypeId', w1,
                    'CategoryId', w2,
                    'SubCategoryId', w3,
                    'BrandId', w1,
                    'CollectionId', w1,
                    'SuperTypeId', w1,
                    'ShapeId', w1,
                    'StoneSizeId', w1,
                    'SieveId', w1,
                    'QualityId', w1,
                    'StoneColorId', w1,
                    'KaratId', w1,
                    'MetalColorId', w1,
                    'ProcessId', w1,
                    'SettingId', w1,
                    'MarkUpRateType', w0,
                    'MarkUp', w4
                ]);
            }
        }
    }
}
